<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CB7G5i/tc-custom/9781607106173.jpg?1704916904400" alt="This image is the cover for the book Uncle John's Bathroom Reader Plunges into History Again, Uncle John's Bathroom Reader"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Uncle John's Bathroom Reader Plunges into History Again, Uncle John's Bathroom Reader
      </h1>
      <p class="bookDescription body article font2">
        <b>History repeats itself as Uncle John presents another volume of funny stories and fascinating facts about the past!</b><br/>  <br/> For our historical trivia collection number two, we dug ever deeper into our bottomless vaults to bring you more of history’s most colorful characters, cultural milestones, funniest mishaps, and earth-shattering events. More than 500 pages of great stories, fascinating facts, and fun quizzes await you.<br/>  <br/> Read about . . . * Philosophers who fought with fireplace pokers * “Mr. Gorbachev, tear down this Wall!” * Where are they now—the Goths * The golden age of wife-selling * History’s most horrible dentist award * The French monks who invented tennis * What William the Conqueror was called before he conquered * Where are they now—the Neanderthals * Women of the Gold Rush * and much, much more! 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bathroom Readers' Institute
      </h2>
      
      <p class="authorDescription body article">The Bathroom Readers' Institute is a tight-knit group of loyal and skilled writers, researchers, and editors who have been working as a team for years. The BRI understands the habits of a very special market—Throne Sitters—and devotes itself to providing amazing facts and conversation pieces.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Portable Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fac3aabc